import {FC, useEffect, useState} from 'react'
import {CheckCheck, RotateCcw, SlidersHorizontal, X} from 'lucide-react'

type Props = {
  onChange: (selectAll: boolean) => void
  onClose: () => void
  item: any
}

const PermissionsModal: FC<Props> = ({item, onChange, onClose}) => {
  const [action, setAction] = useState<'select' | 'clear' | null>(null)

  useEffect(() => {
    setAction(null)
  }, [item])

  return (
    <div className='ua-bulk-modal'>
      <div className='ua-bulk-modal__header'>
        <span className='ua-section__heading-icon'>
          <SlidersHorizontal size={19} />
        </span>
        <div>
          <small>Alteração em massa</small>
          <h3>{item.admin_name || item.name}</h3>
        </div>
        <button type='button' className='ua-icon-button' aria-label='Fechar' onClick={onClose}>
          <X size={15} />
        </button>
      </div>
      <div className='ua-bulk-modal__body'>
        <p>Escolha como essa permissão deve ser aplicada aos usuários da categoria.</p>
        <button
          type='button'
          className='ua-bulk-action is-positive'
          disabled={Boolean(action)}
          onClick={() => {
            setAction('select')
            onChange(true)
          }}
        >
          <span>
            {action === 'select' ? <span className='ua-spinner' /> : <CheckCheck size={18} />}
          </span>
          <span>
            <strong>Conceder para todos</strong>
            <small>Ativa esta permissão para todos os usuários.</small>
          </span>
        </button>
        <button
          type='button'
          className='ua-bulk-action is-negative'
          disabled={Boolean(action)}
          onClick={() => {
            setAction('clear')
            onChange(false)
          }}
        >
          <span>
            {action === 'clear' ? <span className='ua-spinner' /> : <RotateCcw size={18} />}
          </span>
          <span>
            <strong>Remover de todos</strong>
            <small>Desativa esta permissão para todos os usuários.</small>
          </span>
        </button>
      </div>
    </div>
  )
}

export default PermissionsModal
